module.exports = __webpack_public_path__ + "c90940bb89f549ab53d701bcd12491e5.glb";